import ViewAllUsers from "../components/users/ViewAllUsers";

export default function AllUsersPage() {
  return <ViewAllUsers />;
}
